import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "timeline-horizontal p-3" }
const _hoisted_2 = {
  key: 0,
  class: "timeline-scale mb-2"
}
const _hoisted_3 = { class: "timeline-scale-labels" }
const _hoisted_4 = { class: "timeline-label" }
const _hoisted_5 = { class: "timeline-track" }
const _hoisted_6 = {
  key: 1,
  class: "text-muted small"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    title: "",
    "dialog-class": "modal-lg",
    modelValue: _ctx.invoiceId !== null,
    "footer-class": "d-flex justify-content-end",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ($event === false && (_ctx.invoiceId = null)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_LoaderWrapper, { ref: "requestsLoader" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.normalizedItems.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scaleTicks, (tick) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: tick.position
                      }, _toDisplayString(tick.label), 1))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.normalizedItems, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id,
                class: "timeline-row"
              }, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(item.providerLabel), 1),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["timeline-bar", {
            failed: item.status === 'failed',
            pending: item.status === 'pending'
          }]),
                    style: _normalizeStyle({
            left: item.leftPercent + '%',
            width: item.widthPercent + '%'
          })
                  }, [
                    _createElementVNode("span", null, _toDisplayString(item.durationMs != null ? _ctx.formatDuration(item.durationMs) : 'pending'), 1)
                  ], 6)
                ])
              ]))
            }), 128)),
            (!_ctx.normalizedItems.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Нет данных по запросам. "))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 512)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.invoiceId = null)),
        class: "btn btn-outline-secondary btn-sm text-capitalize-first"
      }, _toDisplayString(_ctx.helper.trans('button.ok')), 1)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}